<mat-horizontal-stepper linear [class]="'selectedIndex' + stepper.selectedIndex + ' mat-stepper-label-position-bottom'"
    labelPosition="bottom" #stepper>
    <ng-template matStepperIcon="edit">
        <mat-icon>check</mat-icon>
    </ng-template>
    <mat-step>
        <ng-container *ngIf="currentStep === 0">
            <ng-template matStepLabel>Valida tu rut</ng-template>
            <app-paso-uno-login #selector1 (nextStep)="next()"></app-paso-uno-login>
            <!-- <app-paso-tres></app-paso-tres> -->
        </ng-container>
    </mat-step>
    <mat-step>
        <ng-container *ngIf="currentStep === 1">
            <ng-template matStepLabel>Completa datos rápidos</ng-template>
            <app-paso-dos (nextStep)="next($event)"></app-paso-dos>
        </ng-container>
    </mat-step>
    <mat-step>
        <ng-container *ngIf="currentStep === 2">
            <ng-template matStepLabel>Revisa y confirma</ng-template>
            <app-paso-tres></app-paso-tres>
        </ng-container>
    </mat-step>
</mat-horizontal-stepper>
